import script from "./high-end-class.vue?vue&type=script&setup=true&lang=js"
export * from "./high-end-class.vue?vue&type=script&setup=true&lang=js"

import "./high-end-class.vue?vue&type=style&index=0&id=e1c87070&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1c87070"]])

export default __exports__